export const SHARING_PRIVATE = 'SHARING_PRIVATE'
export const SHARING_PUBLIC = 'SHARING_PUBLIC'
